import React, { Component } from 'react';
import { connect } from 'react-redux';
import { searchItems } from '../../../store/actions/user/User';
import BackDrop from '../Preloader/BackDrop';
import Item from '../ProductAndMenus/Item';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Moment from 'moment';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import Footer from '../../Footer/Footer';

const styles = (theme) => ({
    searchResult: {
        marginTop: '5%',
        [theme.breakpoints.down('sm')]: {
            marginTop: '25%',
        }
    }
})

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 8,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 7,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2,
    }
};

class Search extends Component {
    constructor(props) {
        super(props)
        this.state = {
            today: ''
        }
        this.whichDayIsToday = this.whichDayIsToday.bind(this)
    }
    componentDidMount() {
        const { searchText } = this.props.match.params;
        const payload = {
            searchParam: searchText,
            latitude: localStorage.getItem('latitude') || '-33.865143',
            longitude: localStorage.getItem('longitude') || '151.209900'
        };
        this.props.searchItems(payload);
        this.whichDayIsToday();
    }
    componentDidUpdate(prevProps) {
        const { searchText } = this.props.match.params;
        if (searchText !== prevProps.match.params.searchText) {
            const payload = {
                searchParam: searchText,
                latitude: localStorage.getItem('latitude') || '-33.865143',
                longitude: localStorage.getItem('longitude') || '151.209900'
            };
            this.props.searchItems(payload);
        }
    }
    whichDayIsToday = () => {
        let d = new Date();
        let weekday = new Array(7);
        weekday[0] = 'sunday';
        weekday[1] = 'monday';
        weekday[2] = 'tuesday';
        weekday[3] = 'wednesday';
        weekday[4] = 'thursday';
        weekday[5] = 'friday';
        weekday[6] = 'saturday';
        this.setState({
            today: weekday[d.getDay()]
        })
    };
    handleStatus(days, opentime, closetime) {
        const newOpenTime = Moment(opentime).tz('Australia/Sydney').format('LT');
        const newCloseTime = Moment(closetime).tz('Australia/Sydney').format('LT');
        let difference;
        var closeHours;
        var now = Moment().tz('Australia/Sydney');
        if (newCloseTime) {
            if (newCloseTime.includes('PM')) {
                var openHours, openMin;
                closeHours = parseInt(
                    newCloseTime.substring(0, newCloseTime.indexOf(':'))
                );
                closeHours = closeHours === 12 ? closeHours : closeHours + 12;
                const closeMin = parseInt(
                    newCloseTime.substring(
                        newCloseTime.indexOf(':') + 1,
                        newCloseTime.indexOf(':') + 3
                    )
                );
                // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
                // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
                if (newOpenTime.includes('AM')) {
                    openHours = parseInt(
                        newOpenTime.substring(0, newOpenTime.indexOf(':'))
                    );
                    openHours = openHours === 12 ? 0 : openHours;
                    closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
                    openHours *= 60;
                    openMin = parseInt(
                        newOpenTime.substring(
                            newOpenTime.indexOf(':') + 1,
                            newOpenTime.indexOf(':') + 3
                        )
                    );
                } else {
                    openHours = parseInt(
                        newOpenTime.substring(0, newOpenTime.indexOf(':'))
                    );
                    openHours = openHours === 12 ? openHours : openHours + 12;
                    closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
                    openHours *= 60;
                    openMin = parseInt(
                        newOpenTime.substring(
                            newOpenTime.indexOf(':') + 1,
                            newOpenTime.indexOf(':') + 3
                        )
                    );
                }
                closeHours *= 60;
                const currentHours = now.hours() * 60;
                const currentMinutes = now.minutes();

                const today = new Date().getDay().toString();
                if (days && days.indexOf(today) === -1) {
                    difference = -1;
                } else if (openHours + openMin === closeHours + closeMin) {
                    difference = 1;
                } else if (
                    currentHours + currentMinutes > openHours + openMin &&
                    currentHours + currentMinutes < closeHours + closeMin
                ) {
                    difference = 1;
                } else {
                    difference = -1;
                }
            } // if time in A.M.
            else {
                closeHours = parseInt(
                    newCloseTime.substring(0, newCloseTime.indexOf(':'))
                );
                closeHours = closeHours === 12 ? 0 : closeHours;
                const closeMin = parseInt(
                    newCloseTime.substring(
                        newCloseTime.indexOf(':') + 1,
                        newCloseTime.indexOf(':') + 3
                    )
                );
                const currentHours = now.hours() * 60;
                const currentMinutes = now.minutes();
                if (newOpenTime.includes('AM')) {
                    openHours = parseInt(
                        newOpenTime.substring(0, newOpenTime.indexOf(':'))
                    );
                    openHours = openHours === 12 ? 0 : openHours;
                    closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
                    openHours *= 60;
                    openMin = parseInt(
                        newOpenTime.substring(
                            newOpenTime.indexOf(':') + 1,
                            newOpenTime.indexOf(':') + 3
                        )
                    );
                } else {
                    openHours = parseInt(
                        newOpenTime.substring(0, newOpenTime.indexOf(':'))
                    );
                    openHours = openHours === 12 ? openHours : openHours + 12;
                    closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
                    openMin = parseInt(
                        newOpenTime.substring(
                            newOpenTime.indexOf(':') + 1,
                            newOpenTime.indexOf(':') + 3
                        )
                    );
                }

                closeHours *= 60;

                const today = new Date().getDay().toString();
                if (days && days.indexOf(today) === -1) {
                    difference = -1;
                } else if (openHours + openMin === closeHours + closeMin) {
                    difference = 1;
                } else if (
                    currentHours + currentMinutes > openHours + openMin &&
                    currentHours + currentMinutes < closeHours + closeMin
                ) {
                    difference = 1;
                } else {
                    difference = -1;
                }
            }
        }
        if (difference > 0) {
            return true
        }
        return false
    }
    getItems(isRestaurant, vendor, vendorId, items, days, opentime, closetime) {
        let shopOpen = this.handleStatus(days, opentime, closetime)

        var itemsArray = []
        if (items?.length) {
            items.map(item =>
                itemsArray.push(<Item vendor={vendor} closed={shopOpen ? false : true} id={item.id} vendorId={vendorId} image={item?.image} isMenu={isRestaurant} price={item?.price} description={item?.description} title={item?.name} product={item} />)
            )
        } else {
            itemsArray.push(<div>No Record Found</div>)
        }
        return itemsArray
    }
    render() {
        const { api_progress, searchResult, classes } = this.props;
        const { today } = this.state;
        return (
            <>
                <div className={classes.searchResult} style={{ padding: '5%', paddingTop: '2%', background: '#f6f9fc' }}>
                    <BackDrop open={api_progress}></BackDrop>
                    {searchResult && searchResult.map((s) => {
                        const shopOpen = this.handleStatus(s.vendor.address?.days,
                            s.vendor.timing[today]?.openTime,
                            s.vendor.timing[today]?.closeTime)
                        return (
                            <div>
                                <Typography variant="h5" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                    {s.vendor.name}
                                </Typography>
                                {s.vendor?.distanceAndDuration?.duration && (<div style={{ textAlign: 'left', fontSize: '15px' }}><AccessTimeIcon style={{ fontSize: 14 }} /> {s.vendor?.distanceAndDuration?.duration.text} | {s.vendor?.distance ? (s.vendor?.distance / 1000).toFixed(2) + ' KM' : ''}</div>)}
                                {s.vendor.active && shopOpen ? (<div style={{
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}>{'Open'}</div>)
                                    : (<div style={{
                                        textAlign: 'left',
                                        color: 'red', fontSize: '14px',
                                        fontWeight: 'bold'
                                    }}>{'Closed'}</div>)
                                }
                                <br></br>
                                <Carousel
                                    responsive={responsive}
                                >
                                    {this.getItems(false, s.vendor, s._id, s.products, s.vendor.address?.days,
                                        s.vendor.timing[today]?.openTime,
                                        s.vendor.timing[today]?.closeTime)}
                                </Carousel>
                                <hr></hr>
                            </div>
                        )
                    })}

                </div>
                <Footer />
            </>
        )
    }
}
const mapStateWithProps = (state) => {
    const { searchResult } = state.user
    if (searchResult)
        searchResult.sort((a, b) => { return a.vendor.distanceAndDuration.duration.value - b.vendor.distanceAndDuration.duration.value })
    return {
        searchResult: searchResult,
        api_progress: state.user.api_progress,
    }
};

const mapDispatchToProps = (dispatch) => ({
    searchItems: (data) => dispatch(searchItems(data))
});

export default withStyles(styles)(connect(mapStateWithProps, mapDispatchToProps)(Search));
